import { render } from "./AgentDashboard.vue?vue&type=template&id=d0e04c70"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script